import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const originalAuthorUrlResolver: FieldResolver = (metadata: Metadata) =>
  ({ originalAuthorUrl: metadata.getOriginalAuthorUrl() } as StreamData)

export default originalAuthorUrlResolver
